import { Outlet } from 'react-router';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { ThemeProvider } from './theme/theme';
import { useGlobalStore } from './store/useGlobalStore';
import { errorBoundaryProps } from './components/ErrorBoundary';

export const Root = () => {
  return (
    <ThemeProvider
      useGlobalStore={useGlobalStore}
      errorBoundaryProps={errorBoundaryProps}
    >
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Header />
        <main style={{ flex: 1 }}>
          <Outlet />
        </main>
        <Footer />
      </div>
    </ThemeProvider>
  );
};
